var _mask, _path, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_516_97752",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85151 13.5412C9.85151 12.859 10.2371 12.2497 10.7336 11.7819C11.6541 10.9149 12.2288 9.68477 12.2288 8.32044C12.2288 5.69459 10.1001 3.56592 7.47425 3.56592C4.8484 3.56592 2.71973 5.69459 2.71973 8.32044C2.71973 9.68478 3.29439 10.9149 4.21486 11.7819C4.71143 12.2497 5.09699 12.859 5.09699 13.5412C5.09699 14.5966 5.9526 15.4522 7.00804 15.4522H7.94046C8.9959 15.4522 9.85151 14.5966 9.85151 13.5412Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21486 11.7819L3.39206 12.6554L4.21486 11.7819ZM11.0288 8.32044C11.0288 9.34052 10.6006 10.2587 9.91084 10.9084L11.5564 12.6554C12.7076 11.5711 13.4288 10.029 13.4288 8.32044H11.0288ZM7.47425 4.76592C9.43736 4.76592 11.0288 6.35733 11.0288 8.32044H13.4288C13.4288 5.03185 10.7628 2.36592 7.47425 2.36592V4.76592ZM3.91973 8.32044C3.91973 6.35733 5.51114 4.76592 7.47425 4.76592V2.36592C4.18566 2.36592 1.51973 5.03185 1.51973 8.32044H3.91973ZM5.03766 10.9084C4.34786 10.2587 3.91973 9.34052 3.91973 8.32044H1.51973C1.51973 10.029 2.24091 11.5711 3.39206 12.6554L5.03766 10.9084ZM7.94046 14.2522H7.00804V16.6522H7.94046V14.2522ZM3.89699 13.5412C3.89699 15.2594 5.28986 16.6522 7.00804 16.6522V14.2522C6.61534 14.2522 6.29699 13.9339 6.29699 13.5412H3.89699ZM3.39206 12.6554C3.76438 13.0062 3.89699 13.3214 3.89699 13.5412H6.29699C6.29699 12.3966 5.65848 11.4932 5.03766 10.9084L3.39206 12.6554ZM7.94046 16.6522C9.65865 16.6522 11.0515 15.2594 11.0515 13.5412H8.65151C8.65151 13.9339 8.33316 14.2522 7.94046 14.2522V16.6522ZM9.91084 10.9084C9.29002 11.4932 8.65151 12.3966 8.65151 13.5412H11.0515C11.0515 13.3214 11.1841 13.0062 11.5564 12.6554L9.91084 10.9084Z",
    fill: "black",
    mask: "url(#path-1-inside-1_516_97752)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.28516,
    y1: 17.2293,
    x2: 8.66242,
    y2: 17.2293,
    stroke: "black",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.46836,
    y1: 2.3772,
    x2: 7.46836,
    y2: -0.0000643468,
    stroke: "black",
    strokeWidth: 1.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.6,
    x2: 2.37726,
    y2: -0.6,
    transform: "matrix(-0.723227 -0.690611 -0.690611 0.723227 2.71973 4.59644)",
    stroke: "black",
    strokeWidth: 1.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.1462,
    y1: 4.1625,
    x2: 13.8655,
    y2: 2.52074,
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/light-bulb-icon.89dc9afb20e397b13c2a200e42ff39b5.svg";
export { ForwardRef as ReactComponent };